export default __webpack_public_path__ + "static/zaklepschronisko-promo@2x-f877bea0908aa56f181090f3ebe43f8c.webp";